import type { MonitorStreamEvent } from '@interfaces/IMonitorApi';
import { SseChannel, siteStreamUrl, type ISseChannelHandlers } from './sseChannel';

// Browser-side client for the monitor's multiplexed `/api/sites/:siteId/monitor/
// stream` channel. The connection machinery lives in `SseChannel`; what is
// monitor-specific is the `_resync` channel — the backend's "your snapshot is
// stale, refetch" frame, which is a control message rather than data and so
// gets its own handler instead of reaching `onEvent`.

export type MonitorStreamHandlers = ISseChannelHandlers<MonitorStreamEvent> & {
  onResync: (channel: 'floors' | 'dashboardData' | 'activities' | 'safety') => void;
};

export class MonitorStream {
  private readonly channel: SseChannel<MonitorStreamEvent>;

  constructor(siteId: string, handlers: MonitorStreamHandlers) {
    this.channel = new SseChannel(siteStreamUrl(siteId, 'monitor/stream'), {
      ...handlers,
      onEvent: (event) => {
        if (event.channel === '_resync') {
          handlers.onResync(event.data.resyncChannel);
          return;
        }
        handlers.onEvent(event);
      },
    });
  }

  open(): void {
    this.channel.open();
  }

  close(): void {
    this.channel.close();
  }
}
